export class ExpenseQuickEntryCategoryApiModel {

    public CategoryID: number;
    public CategoryName: string;

    public IsActive: boolean;

    public UserID: number;
    public IsAvailableToPublic: boolean;

    public Created: Date;
    public Updated: Date;
}